export const swmProdConfig = {
  WEB_API_NAME: "archform-dashboard-migrate",
  BACK_API_NAME: "archform-dashboard-back",
  BACK_API_NAME_V2: "archform-backend",
  BACK_API_V2_ACCESS_POLICY_API: "archform-backend-access-policy-api",
  S3_BUCKET_ARCHFORM_TEMP_FILE: "archform-temp-file-sierra-prod",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1: "archform-patient-data-v1-sierra-prod",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V1_RESIZED: "archform-patient-data-v1-resized-sierra-prod",
  S3_BUCKET_ARCHFORM_PATIENTS_V1: "archform-patients-v1-sierra-prod",
  S3_BUCKET_ARCHFORM_PATIENT_DATA_V2: "archform-patient-data-v2",
  S3_BUCKET_ARCHFORM_PATIENTS_V2: "archform-patients-v2-sierra-prod",
  S3_BUCKET_ARCHFORM_WEBVIEWER_DATA_V2: "archform-webviewer-data-v2-sierra-prod",
  S3_BUCKET_ARCHFORM_AUTO_RETAINER_DATA: "archform-autoretainer-data-test",
  AWS_REGION: "eu-south-1",
  AMPLIFY_USER_POOL_ID: "eu-south-1_U4OwXIIEc",
  AMPLIFY_IDENTITY_POOL_ID: "eu-south-1:9adca4d6-38a5-4f4f-8141-a8d727196834",
  AMPLIFY_USER_POOL_WEB_CLIENT_ID: "2ghhsbtgbnqtfsbgunh02q9tt5",
  
  WEB_API_ENDPOINT: "https://75pt0vm9ng.execute-api.eu-south-1.amazonaws.com/Prod/",
  BACK_API_ENDPOINT: "https://75pt0vm9ng.execute-api.eu-south-1.amazonaws.com/Prod",
  BACK_API_ENDPOINT_V2: "https://f07qgi0py0.execute-api.eu-south-1.amazonaws.com/Prod",
}
